// extracted by mini-css-extract-plugin
export default {"inputsContainer":"style_inputsContainer__Aq3RW","lineStyle":"style_lineStyle__I-wNT","noticeText":"style_noticeText__xNT8X"};